<template>
  <!-- 资质维护 -->
  <div class="registCertificate">
    <!-- 页头 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['客户管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button type="primary" icon="el-icon-s-grid" @click="uphold"
          >客户分类</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="selectedList.length == 0"
          @click="handleDel"
          >批量删除</el-button
        >
        <el-button type="primary" icon="el-icon-link" @click="handleBind"
          >绑定ERP分类</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="状态"
          style="width: 100px; margin-right: 5px"
        >
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <label class="label">领取类型：</label>
        <el-select
          v-model="searchForm.type"
          placeholder="领取类型"
          style="width: 100px; margin-right: 5px"
        >
          <el-option
            v-for="(item, index) in typeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="seach"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column
        width="55"
        label="序号"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="typename"
        align="center"
        show-overflow-tooltip
        label="商城角色类型"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="clienttype"
        show-overflow-tooltip
        label="ERP角色类型"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="运营方式"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === '0'" type="primary">正常</el-tag>
          <el-tag v-if="scope.row.status === '-1'" type="primary"
            >已删除</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleCerti(scope.row)"
            >资质管理</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 绑定ERP分类 -->
    <el-dialog
      title="绑定ERP分类"
      :visible.sync="erpDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="40%"
    >
      <el-form
        :model="erpForm"
        :rules="formRule"
        label-width="150px"
        label-position="right"
        ref="erpForm"
      >
        <el-form-item prop="type" label="商城分类名称">
          <el-select
            v-model="erpForm.type"
            placeholder="商城分类名称"
            clearable
            style="width: 80%"
          >
            <el-option
              v-for="(item, index) in erpTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="erpType" label="ERP分类名称">
          <el-select
            v-model="erpForm.erpType"
            placeholder="ERP分类名称"
            clearable
            style="width: 80%"
          >
            <el-option
              v-for="(item, index) in erpTypeNameList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="submitForm">提交</el-button>
        <el-button type="info" @click="resetForm">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//混入
import { mustFill } from "@/mixins/data/valid.js"; //混入表单必填项

export default {
  name: "registCertificate",
  data() {
    return {
      /**表格数据 */
      // {
      //   operaRoles:"运营角色",
      //   roleType:"角色类型",
      //   operaMode:"运营方式",
      //   status:"状态"
      // }
      tableData: [],
      statusList: [
        {
          value: "9",
          label: "全部",
        },
        {
          value: "0",
          label: "正常",
        },
        {
          value: "-1",
          label: "已删除",
        },
      ],
      typeList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "F001",
          label: "医疗机构",
        },
        {
          value: "F002",
          label: "零售药店",
        },
        {
          value: "F003",
          label: "生产企业",
        },
        {
          value: "F004",
          label: "商业公司",
        },
      ],
      erpTypeList: [],
      erpTypeNameList: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        status: "9",
        type: "",
        name: "",
      },
      /**select选中项 */
      selectedList: [],
      /**绑定erpdialog */
      erpDialog: false,
      /**绑定erp表单 */
      erpForm: {
        type: "",
        erpType: "",
      },
      formRule: {
        type: [mustFill],
        erpType: [mustFill],
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    seach() {
      this.getTableData(1);
    },
    uphold() {
      this.$router.push("memClassify");
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "PC_CustomerTypeBFList",
        typeid: this.searchForm.type,
        status: this.searchForm.status,
        name: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "PC_CustomerType"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "qualification/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          console.log(res);
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**点击注册资质 */
    handleCerti(row) {
      let prams = {
        id: row.ID,
        name: row.clienttype,
        typeid: row.TypeID,
      };
      prams = JSON.stringify(prams);
      this.$router.push({
        path: "certificate",
        query: {
          row: prams,
        },
      });
      prams = null;
    },
    /**点击批量删除 */
    handleDel() {
      let idList = [];
      this.selectedList.forEach((i) => {
        idList.push(i.id);
      });
      idList = idList.join();
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          let data = {
            type: "PC_DelCustomerType",
            strWhere: idList,
          };
          let proc = "PC_CustomerType"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            method: "post",
            url:
              "qualification/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    /**点击绑定erp分类 */
    handleBind() {
      this.getErpDate();
      this.getErpNameDate();
      this.erpDialog = true;
    },
    // 获取客户分类列表
    getErpDate() {
      let data = {
        type: "GetClientType",
      };
      let proc = "PC_CustomerType"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "qualification/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          this.erpTypeList = [];
          if (res.flag == 0) {
            res.data.forEach((item) => {
              this.erpTypeList.push({
                value: item.TypeID,
                label: item.clienttype,
              });
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取erp分类名称列表
    getErpNameDate() {
      let data = {
        type: "GetErpClientType",
      };
      let proc = "PC_CustomerType"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "qualification/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          this.erpTypeNameList = [];
          if (res.flag == 0) {
            res.data.forEach((item) => {
              this.erpTypeNameList.push({
                value: item.clienttype,
                label: item.clienttype,
              });
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**提交绑定erp表单 */
    submitForm() {
      this.$refs["erpForm"].validate((valid) => {
        if (valid) {
          let data = {
            type: "SaveErpClientType",
            name: this.erpForm.type,
            Clienttype: this.erpForm.erpType,
          };
          let proc = "PC_CustomerType"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            method: "post",
            url:
              "qualification/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
                this.resetForm();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        }
      });
    },
    /**重置表单 */
    resetForm() {
      for (let key in this.erpForm) {
        this.erpForm[key] = "";
      }
      this.erpDialog = false;
    },
  },
};
</script>

<style scoped>
.registCertificate {
  width: 100%;
  height: 100%;
}
</style>
